export type NavigationPlatform = "android" | "ios" | "desktop";

export interface NavigationPlatformHints {
  userAgent?: string;
  platform?: string;
  maxTouchPoints?: number;
}

export interface NavigationDestination {
  latitude: number;
  longitude: number;
}

export const detectNavigationPlatform = ({
  userAgent = "",
  platform = "",
  maxTouchPoints = 0,
}: NavigationPlatformHints): NavigationPlatform => {
  if (/android/i.test(userAgent)) return "android";

  const isAppleMobile = /iPad|iPhone|iPod/i.test(userAgent);
  const isIPadDesktopMode = platform === "MacIntel" && maxTouchPoints > 1;
  return isAppleMobile || isIPadDesktopMode ? "ios" : "desktop";
};

export const buildGoogleMapsDirectionsUrl = ({ latitude, longitude }: NavigationDestination): string =>
  `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;

export const buildAppleMapsDirectionsUrl = ({ latitude, longitude }: NavigationDestination): string =>
  `https://maps.apple.com/?daddr=${latitude},${longitude}&dirflg=d`;

export const buildNavigationUrl = (
  destination: NavigationDestination,
  platform: NavigationPlatform
): string => platform === "ios"
  ? buildAppleMapsDirectionsUrl(destination)
  : buildGoogleMapsDirectionsUrl(destination);
